/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON, status from the response
 */
function parseJSON(response) {
    return new Promise((resolve, reject) => response.json().then(
        json => resolve({
            status: response.status,
            ok: response.ok,
            json
        }),
        error => reject({
            status: response.status,
            ok: response.ok,
            json: {message: "not valid JSON", error: error.message}
        })
    ));
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @param  {string} [token]   If token is set, add this token to the authorization header
 *
 * @return {Promise}           The request promise
 */
export default function request(url, options, token) {
    let headers;

    // If it's an API location, add authorization token to header
    let fetchOptions;
    if(token) {
        if (options && options.headers) {
            headers = options.headers;
            headers.append('Authorization', `Token ${token}`)
        } else {
            headers = new Headers({"Content-Type": "application/json", "Authorization": `Token ${token}`})
        }
        fetchOptions = Object.assign({}, options, {headers});
    } else {
        fetchOptions = Object.assign({}, options);
    }

    //console.log("Fetching from ", url)
    return new Promise((resolve, reject) => {
        fetch(url, fetchOptions)
            .then(parseJSON)
            .then((response) => {
                if (response.ok) {
                    //console.log(JSON.stringify(response.json))
                    return resolve(response.json);
                }
                // extract the error from the server's json
                //console.log("E:", response);
                return reject(response.json);
            })
            .catch((error) => reject({
                networkError: error.message
            }));
    });
}